<template>
  <div class="content-container">
    <search-component @onSearch="onSearch" @onReset="attachData" />
    <div class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-select-first-row="false"
        :row-multi-select-with-click="true"
        dom-layout="scroll"
        :rows="rows"
        class="agGrid"
        @selectionChanged="onRowSelected"
      />
    </div>
    <div class="flex justify-space-between">
      <div class="button-containers mb-0">
        <button
          class="btn primary small outline"
          @click="infoDialogVisible = true"
        >
          Chú thích
        </button>
      </div>
      <div class="button-containers mb-0">
        <button
          :disabled="isOOORoom || selectedRows.length === 0"
          class="btn primary small"
          @click="changeRoomCondition(1)"
        >
          {{ $t('button.dirty') }}
        </button>
        <button
          :disabled="isOOORoom || selectedRows.length === 0"
          class="btn primary small"
          @click="changeRoomCondition(2)"
        >
          {{ $t('button.clean') }}
        </button>
        <!-- <button class="btn primary small">
        {{ $t('button.lightClean') }}
      </button> -->
        <button
          v-if="checkAuthorRoomChecked"
          :disabled="isOOORoom || selectedRows.length === 0"
          class="btn primary small"
          @click="changeRoomCondition(4)"
        >
          {{ $t('button.checked') }}
        </button>
        <button
          :disabled="isOOORoom || selectedRows.length !== 1"
          class="btn primary small"
          @click="openChangePeopleNumDialog()"
        >
          {{ $t('button.changePeopleNum') }}
        </button>
        <button
          v-if="checkAuthorTaskAssign"
          :disabled="isOOORoom || selectedRows.length === 0"
          class="btn primary small"
          @click="openTaskAssignmentDialog"
        >
          {{ $t('button.roomTaskAssignment') }}
        </button>
        <button
          :disabled="isOOORoom || selectedRows.length === 0"
          class="btn primary small"
          @click="changeRoomCondition(null, 0)"
        >
          {{ $t('button.empty') }}
        </button>
        <button
          :disabled="isOOORoom || selectedRows.length === 0"
          class="btn primary small"
          @click="changeRoomCondition(null, 1)"
        >
          {{ $t('button.occupied') }}
        </button>
        <!-- <button class="btn primary small" @click="dialogFormVisible2 = true">
        {{ $t('button.staffMng') }}
      </button> -->
      </div>
    </div>
    <!-- PHAN CONG DON PHONG -->
    <el-dialog
      :title="$t('dialog.titleTaskAssignment')"
      class="body-overflow__visible"
      :visible.sync="taskAssignmentDialogVisible"
      :close-on-click-modal="false"
      width="700px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-group-title">Thông tin NV</div>
          <hr />
          <div style="height: 300px">
            <GridVx
              ref="agGridStaffs"
              :columns="staffCols"
              dom-layout="scroll"
              :auto-select-first-row="false"
              :auto-size-cell="true"
              :rows="rows1"
              class="agGrid"
            />
          </div>
        </div>
        <validation-observer ref="formValidatorTaskAssignment">
          <div class="das-form-group">
            <div class="das-form-group-title">Thông tin gán phòng</div>
            <hr />
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Tăng ca</div>
                  <div class="checkbox-container">
                    <div class="checkbox-wrap">
                      <input
                        id="cpSpdTp3"
                        v-model="taskAssignmentForm.ot"
                        type="checkbox"
                      />
                      <label for="cpSpdTp3">Tăng ca</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Ngày</div>
                  <validation-provider rules="required" name="Ngày">
                    <input
                      v-model="taskAssignmentForm.date_from"
                      type="text"
                      style="display: none"
                    />
                  </validation-provider>
                  <validation-provider rules="required" name="Ngày tăng ca">
                    <input
                      v-model="taskAssignmentForm.date_to"
                      type="text"
                      style="display: none"
                    />
                  </validation-provider>
                  <MultiCalendar
                    :from-date="taskAssignmentForm.date_from"
                    :to-date="taskAssignmentForm.date_to"
                    @changeDate="onChangeOTDate"
                  />
                </div>
              </div>
              <div v-if="taskAssignmentForm.ot" class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Thời gian tăng ca</div>
                  <div class="flex">
                    <validation-provider
                      rules="required"
                      name="Thời gian tăng ca"
                    >
                      <TimePicker
                        v-model="taskAssignmentForm.ot_from"
                        @change="onChangeOTFrom"
                      />
                    </validation-provider>
                    <div class="date-divide" style="align-self: center"></div>
                    <validation-provider
                      rules="required"
                      name="Thời gian tăng ca"
                    >
                      <TimePicker
                        v-model="taskAssignmentForm.ot_to"
                        @change="onChangeOTTo"
                      />
                    </validation-provider>
                  </div>
                </div>
              </div>
              <div v-else class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Chọn ca</div>
                  <validation-provider rules="required" name="Ca làm việc">
                    <el-select
                      v-model="taskAssignmentForm.shift_id"
                      placeholder=""
                    >
                      <el-option label="Chọn" :value="null"></el-option>
                      <el-option
                        v-for="item in shiftOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required" name="Mô tả">
                  <div class="das-form-input">
                    <div class="label required">Mô tả</div>
                    <textarea v-model="taskAssignmentForm.note" :rows="3" />
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="taskAssignmentDialogVisible = false"
          >
            Hủy
          </button>
          <button class="btn primary small" @click="submitTaskAssignment">
            Gán phòng
          </button>
          <button class="btn primary small" @click="openOTDialog">
            Danh sách tăng ca
          </button>
          <!-- <button class="btn primary small" disabled>In</button> -->
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="Danh sách tăng ca"
      :visible.sync="otDialogVisible"
      :close-on-click-modal="false"
      width="1000px"
    >
      <div class="das-form-container">
        <search-comp
          :search-show="true"
          @onSearch="onSearchOT"
          @onReset="onResetOT"
        >
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row m-0">
                <div class="das-form-col col-4">
                  <div class="label">Tên NV</div>
                  <input v-model="otSearchParams.staffName" type="text" />
                </div>
                <div class="das-form-col col-4">
                  <div class="label">Ngày</div>
                  <MultiCalendar
                    :from-date="otSearchParams.dateFrom"
                    :to-date="otSearchParams.dateTo"
                    @changeDate="changeOTSearch"
                  />
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div style="height: 400px">
          <GridVx
            ref="agGridOT"
            dom-layout="scroll"
            :columns="otCols"
            :auto-size-cell="true"
            :row-multi-select-with-click="true"
            :rows="otRows"
            class="agGrid"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="otDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button class="btn primary small outline" @click="deleteOtRows">
            {{ $t('button.delete') }}
          </button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="Chú thích"
      :visible.sync="infoDialogVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <div style="height: 325px">
        <GridVx
          :columns="infoCols"
          :auto-size-cell="true"
          dom-layout="scroll"
          :rows="infoRows"
          class="agGrid"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="infoDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="Thay đổi số lượng người"
      :visible.sync="changePeopleNumDialogVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <validation-observer ref="editForm">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-info-title">Thông tin phòng</div>
            <InfoList :columns="2">
              <InfoListLabel>Số phòng</InfoListLabel>
              <InfoListValue>{{ changePeopleNumIf.room_num }}</InfoListValue>

              <InfoListLabel>Hạng phòng</InfoListLabel>
              <InfoListValue>{{
                changePeopleNumIf.room_level_name
              }}</InfoListValue>
            </InfoList>

            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|number|max:2"
                  name="Số lượng người"
                >
                  <div class="das-form-input">
                    <div class="label">Số lượng người</div>
                    <input
                      v-model="changePeopleNumIf.people_num"
                      type="number"
                    />
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="changePeopleNumDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            class="btn primary small"
            @click="
              changeRoomCondition(null, null, changePeopleNumIf.people_num)
            "
          >
            {{ $t('button.save') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import InfoBtn from '@/views/mci/report/components/InfoBtn.vue'
import { getListShiftApi } from '@/api/configuration/hotel/shift.js'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'
import { checkAuthorized } from '@/utils/helper'
import {
  getListHouseKeepingApi,
  changeStatusHouseKeepingApi,
  // eslint-disable-next-line no-unused-vars
  houseKeepingAssignApi,
  getListStaffApi,
  getListOT,
  deleteListOT
} from '@/api/houseKeeper/house-keeping-mng.js'
import SearchComponent from './components/taskAssignmentSearchComponent.vue'
// import SingleCalendar from '@/components/ui/SingleCalendar.vue'
// import MultiCalendar from '@/components/ui/MultiCalendar.vue'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckboxReadonly,
    SearchComponent
    // SingleCalendar
    // MultiCalendar
    // InfoBtn
  },
  data() {
    return {
      // author
      checkAuthorTaskAssign: false,
      checkAuthorRoomChecked: false,
      changePeopleNumIf: {
        room_num: null,
        room_level_name: null,
        people_num: null
      },
      changePeopleNumDialogVisible: false,
      otSearchParams: {
        staffName: null,
        dateFrom: null,
        dateTo: null
      },
      otCols: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Tên NV',
          field: 'staff_name',
          tooltipField: 'staff_name'
        },
        {
          headerName: 'Số phòng',
          field: 'room_num',
          tooltipField: 'room_num'
        },
        {
          headerName: 'Hạng phòng',
          field: 'room_level',
          tooltipField: 'room_level'
        },
        {
          headerName: 'Ngày',
          field: 'date',
          tooltipField: 'date'
        },
        {
          headerName: 'Bắt đầu',
          field: 'ot_from',
          tooltipField: 'ot_from'
        },
        {
          headerName: 'Kết thúc',
          field: 'ot_to',
          tooltipField: 'ot_to'
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          tooltipField: 'note'
        }
      ],
      otRows: [],
      otDialogVisible: false,
      isWorkOverTime: false,
      selectedRows: [],
      isOOORoom: false,
      infoDialogVisible: false,
      shiftOptions: [],
      allRoomLevelOptions: [],
      taskAssignmentForm: {
        staff_ids: [],
        housekeeping_ids: [],
        shift_id: null,
        note: null,
        ot: false,
        date_from: null,
        date_to: null,
        ot_from: null,
        ot_to: null
      },
      searchParams: {
        // room_start: null,
        // room_end: null,
        hotel_ids: [],
        room_level: null,
        room_status: [],
        booking_status: [],
        shift_id: null,
        assign: null,
        diff: [],
        drif: null,
        date: this.$moment(new Date()).format('YYYY-MM-DD')
      },
      taskAssignmentDialogVisible: false,
      // dialogFormVisible2: false,
      phone: null,
      options: {
        placeholder: 'abc'
      },
      rows1: [],
      rows2: [],
      time1: new Date(),
      searchShow: true,
      infoCols: [
        {
          headerName: 'Loại',
          field: 'type',
          maxWidth: 150,
          cellStyle: params => {
            const data = params.data.type
            const property = {
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: null
            }
            if (data === 'VCI' || data === 'OCI') {
              // checked
              property.backgroundColor = '#c3edd9'
              property.color = '#357456'
            } else if (data === 'VD' || data === 'OD') {
              // dirty
              property.backgroundColor = '#ffdfe1'
              property.color = '#f12b37'
            } else if (data === 'OOS' || data === 'OOO') {
              property.backgroundColor = '#cdcccc'
              property.color = '#575757'
            } else if (
              data === 'Sleep' ||
              data === 'Skip' ||
              data === 'People'
            ) {
              property.backgroundColor = '#fff'
              property.color = '#000'
            } else {
              // clean
              property.backgroundColor = '#ffecd5'
              property.color = '#ea7e00'
            }
            return property
          }
        },
        {
          headerName: 'Nội dung',
          field: 'content'
        }
      ],
      infoRows: [
        {
          type: 'OC',
          content: 'Phòng có khách, sạch'
        },
        {
          type: 'OD',
          content: 'Phòng có khách, bẩn'
        },
        {
          type: 'OCI',
          content: 'Phòng có khách, sạch, đã kiểm tra'
        },
        {
          type: 'VC',
          content: 'Phòng trống khách, sạch'
        },
        {
          type: 'VD',
          content: 'Phòng trống khách, bẩn'
        },
        {
          type: 'VCI',
          content: 'Phòng trống khách, sạch, đã kiểm tra'
        },
        {
          type: 'OOO',
          content: 'Phòng ngừng sử dụng'
        },
        {
          type: 'OOS',
          content: 'Phòng không phục vụ'
        },
        {
          type: 'Sleep',
          content: 'Buồng có khách, lễ tân trống khách'
        },
        {
          type: 'Skip',
          content: 'Lễ tân có khách, buồng trống khách'
        },
        {
          type: 'People',
          content: 'Số lượng khách giữa buồng và lễ tân khác nhau'
        }
      ],
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Phòng',
          field: 'room_num',
          tooltipField: 'room_num'
        },
        {
          headerName: 'Hạng',
          tooltipField: 'room_level_name',
          field: 'room_level_name'
        },
        {
          headerName: 'Nhân viên dọn phòng',
          field: 'staff_clean_name',
          tooltipField: 'staff_clean_name',
          width: 180
        },
        {
          headerName: 'Trạng thái phòng',
          headerClass: [
            'header-cell-suffix-group',
            'header-group-cell-divide',
            'header-cell-center'
          ],
          // headerClass: 'ag-grid-header-cell-border-bottom',
          // marryChildren: true,
          children: [
            {
              field: 'room_status',
              headerName: 'Buồng',
              width: 100,
              tooltipField: 'room_status',
              cellStyle: params => {
                const data = params.data.room_status
                const property = {
                  fontWeight: 'bold',
                  color: 'white',
                  backgroundColor: null
                }
                if (data === 'VCI' || data === 'OCI') {
                  // checked
                  property.backgroundColor = '#c3edd9'
                  property.color = '#357456'
                } else if (data === 'VD' || data === 'OD') {
                  // dirty
                  property.backgroundColor = '#ffdfe1'
                  property.color = '#f12b37'
                } else if (data === 'OOS' || data === 'OOO') {
                  property.backgroundColor = '#cdcccc'
                  property.color = '#575757'
                } else {
                  // clean
                  property.backgroundColor = '#ffecd5'
                  property.color = '#ea7e00'
                }
                return property
              }
            },
            {
              field: 'room_type_reception',
              tooltipField: 'room_type_reception',
              headerName: 'Lễ tân',
              headerClass: 'header-cell-center',
              cellRenderer: 'CellRenderCheckboxReadonly',
              cellClass: 'grid-cell-align-center',

              // valueGetter: params => {
              //   switch (params.data.room_type_reception) {
              //     case 0:
              //       return 'V'
              //     case 1:
              //       return 'O'
              //     default:
              //       return null
              //   }
              // },
              width: 100
            }
          ]
        },
        {
          headerName: 'Số lượng người',
          headerClass: [
            'header-cell-suffix-group',
            'header-group-cell-divide',
            'header-group-cell-divide-right',
            'header-cell-center'
            // 'header-cell-center'
          ],
          // headerClass: 'ag-grid-header-cell-border-bottom',
          // marryChildren: true,
          children: [
            {
              field: 'people_number_chamber',
              tooltipField: 'people_number_chamber',
              headerName: 'Buồng',
              width: 100
            },
            {
              field: 'people_number_reception',
              tooltipField: 'people_number_reception',
              headerName: 'Lễ tân',
              width: 100
            }
          ]
        },
        {
          headerName: 'SKip/Sleep/Person',
          field: 'diff',
          tooltipField: 'diff',
          width: 160
        },
        {
          headerName: 'Hạng khách',
          field: 'customer_level',
          tooltipField: 'customer_level',
          width: 120
        },
        {
          headerName: 'Dịch vụ đặc biệt',
          field: 'special_service',
          tooltipField: 'special_service',
          width: 150
        },
        {
          headerName: 'Đặt phòng đang ở',
          field: '',
          tooltipField: '',
          valueGetter: params => {
            if (params.data.from_date && params.data.to_date) {
              return (
                this.$displayDate(params.data.from_date) +
                ' - ' +
                this.$displayDate(params.data.to_date)
              )
            } else {
              return null
            }
          }
        },
        {
          headerName: 'Đặt phòng tiếp theo',
          field: '',
          tooltipField: '',
          valueGetter: params => {
            if (params.data.from_date_next && params.data.to_date_next) {
              return (
                this.$displayDate(params.data.from_date_next) +
                ' - ' +
                this.$displayDate(params.data.to_date_next)
              )
            } else {
              return null
            }
          }
        },
        {
          headerName: 'Trạng thái đặt phòng',
          field: 'booking_room_status',
          tooltipField: 'booking_room_status',
          width: 180
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          tooltipField: 'note'
        }
      ],
      staffCols: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'ID NV buồng',
          field: 'id',
          tooltipField: 'id',
          width: 100
        },
        {
          headerName: 'Tên nhân viên',
          field: 'full_name',
          tooltipField: 'full_name'
        }
      ],
      rows: []
    }
  },
  computed: {},
  watch: {
    otDialogVisible() {
      this.$nullValueInObj(this.otSearchParams)
      this.otSearchParams.staffName = null
    },
    taskAssignmentDialogVisible() {
      // reset params
      this.$nullValueInObj(this.taskAssignmentForm)
      //
      this.taskAssignmentForm.staff_ids = []
      this.taskAssignmentForm.housekeeping_ids = []
    },
    'taskAssignmentForm.ot'() {
      if (this.taskAssignmentForm.ot) {
        this.taskAssignmentForm.shift_id = null
      } else {
        this.taskAssignmentForm.ot_from = null
        this.taskAssignmentForm.ot_to = null
      }
    }
  },
  async mounted() {
    // check author
    this.checkAuthorRoomChecked = checkAuthorized('SCHEDULE_HOUSEKEEPING_READY')
    this.checkAuthorTaskAssign = checkAuthorized('SCHEDULE_HOUSEKEEPING_ASSIGN')
    //
    this.getShiftOptions()
  },
  methods: {
    onSearch(params) {
      Object.assign(this.searchParams, params)
      this.attachData(this.searchParams)
    },
    async getShiftOptions() {
      const data = await getListShiftApi()
      this.shiftOptions = data.data || []
    },
    openChangePeopleNumDialog() {
      const selectedRow = this.selectedRows[0]
      // assign data
      this.changePeopleNumIf.room_num = selectedRow.room_num
      this.changePeopleNumIf.room_level_name = selectedRow.room_level_name
      this.changePeopleNumIf.people_num =
        Number(selectedRow.people_number_chamber) || 0
      //
      this.changePeopleNumDialogVisible = true
    },
    onChangeSearchDate(date) {
      this.searchParams.date = date
    },
    async deleteOtRows() {
      const agGrid = this.$refs.agGridOT.gridApi
      const selectedRows = agGrid.getSelectedRows()
      const ids = selectedRows.map(item => item.id)
      this.$vxConfirm(this.$t('alert.deleteOTConfirm'), async () => {
        await deleteListOT({
          ids: ids
        })
          .then(async res => {
            const message = res.message
            await this.onSearchOT()
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    async onSearchOT() {
      const data = await getListOT(this.otSearchParams)
      this.otRows = data.data
    },
    async onResetOT() {
      this.$nullValueInObj(this.otSearchParams)
      await this.onSearchOT()
    },
    changeOTSearch(from, to) {
      this.otSearchParams.dateFrom = from
      this.otSearchParams.dateTo = to
    },
    async openOTDialog() {
      await this.onSearchOT()
      this.otDialogVisible = true
    },
    onChangeOTFrom(time) {
      this.taskAssignmentForm.ot_from = time.displayTime
    },
    onChangeOTTo(time) {
      this.taskAssignmentForm.ot_to = time.displayTime
    },
    onChangeOTDate(from, to) {
      this.taskAssignmentForm.date_from = from
      this.taskAssignmentForm.date_to = to
    },
    onReset() {
      this.searchParams = {
        // room_start: null,
        // room_end: null,
        hotel_ids: [],
        room_level: null,
        room_status: [],
        booking_status: [],
        shift_id: null,
        assign: null,
        diff: [],
        drif: null,
        date: this.$moment(new Date()).format('YYYY-MM-DD')
      }
      this.attachData(this.searchParams)
    },
    async changeRoomCondition(
      roomStatus = null,
      roomType = null,
      peopleNum = null
    ) {
      // check is change people num event
      if (!roomStatus && !roomType) {
        if ((await this.$vxForm.isValid(this.$refs.editForm)) === false) {
          return
        }
      }
      const selectedIds = this.selectedRows.map(item => item.room_id) || []
      const data = {
        room_ids: selectedIds,
        room_status: roomStatus,
        room_type: roomType,
        people_num: peopleNum
      }
      await changeStatusHouseKeepingApi(data)
        .then(async res => {
          const message = res.message
          await this.attachData(this.searchParams)
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          if (peopleNum) {
            this.changePeopleNumDialogVisible = false
          }
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async submitTaskAssignment() {
      // validate
      if (
        (await this.$vxForm.isValid(this.$refs.formValidatorTaskAssignment)) ===
        false
      ) {
        return
      }
      // taskAssignmentForm
      if (
        !this.$compareTime(
          this.taskAssignmentForm.ot_from,
          this.taskAssignmentForm.ot_to
        )
      ) {
        return false
      }
      const gridApi2 = this.$refs.agGridStaffs.gridApi
      const selectedStaffs = gridApi2.getSelectedRows()
      this.selectedRows.forEach(item => {
        this.taskAssignmentForm.housekeeping_ids.push(item.id)
      })
      selectedStaffs.forEach(item => {
        this.taskAssignmentForm.staff_ids.push(item.id)
      })
      if (this.taskAssignmentForm.staff_ids.length === 0) {
        this.$message({
          type: 'error',
          message: 'Cần phải chọn nhân viên dọn phòng'
        })
        return
      }
      await houseKeepingAssignApi(this.taskAssignmentForm)
        .then(async res => {
          const message = res.message
          await this.attachData(this.searchParams)
          this.taskAssignmentDialogVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData(params) {
      const data = await getListHouseKeepingApi(params)
      this.rows = data.data
      this.selectedRows = []
    },
    async openTaskAssignmentDialog() {
      if (this.selectedRows.length === 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      } else if (this.selectedRows.length === 1) {
        this.taskAssignmentForm.note = this.selectedRows[0].note
      } else {
        this.taskAssignmentForm.note = null
      }
      // Object.assign()
      const staffs = await getListStaffApi()
      this.rows1 = staffs.data
      this.taskAssignmentDialogVisible = true
    },
    onDoubleClicked() {},
    onRowSelected(row) {
      // console.log('rowSelection', row)
      const gridApi = this.$refs.agGrid.gridApi
      this.selectedRows = gridApi.getSelectedRows()
      this.isOOORoom = false
      this.selectedRows.forEach(item => {
        if (item.room_status === 'OOO' || item.room_status === 'OOS') {
          this.isOOORoom = true
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.filter_container {
  margin-top: 10px;
  padding: 20px;
  background: #fff;
}
.edit-container {
  padding: 10px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  background: #fff;

  position: absolute;
  width: calc(100% - 60px);
  bottom: 15px;

  box-shadow: 0px 4px 22px 0px rgba(54, 59, 80, 0.2);
  .right-content {
    display: flex;
    gap: 10px;
  }
}
</style>
